import { Record } from "../../fable_modules/fable-library.3.7.20/Types.js";
import { record_type, int32_type, lambda_type, class_type, list_type } from "../../fable_modules/fable-library.3.7.20/Reflection.js";
import * as react from "react";
import { skip, truncate, empty, length } from "../../fable_modules/fable-library.3.7.20/List.js";
import { logw } from "../../Utils.js";
import { printf, toText } from "../../fable_modules/fable-library.3.7.20/String.js";
import { uncurry, max, comparePrimitives, min } from "../../fable_modules/fable-library.3.7.20/Util.js";
import { getMaterialIcon } from "../../ViewUtils.js";
import { FunctionComponent_Of_Z5A158BBF } from "../../fable_modules/Fable.React.7.4.3/Fable.React.FunctionComponent.fs.js";
import "../../../src/Components/Pagination/Pagination.scss";


export class PageinationProps$1 extends Record {
    constructor(RenderFunc, Elements, PageSize, StartPage) {
        super();
        this.RenderFunc = RenderFunc;
        this.Elements = Elements;
        this.PageSize = (PageSize | 0);
        this.StartPage = (StartPage | 0);
    }
}

export function PageinationProps$1$reflection(gen0) {
    return record_type("Components.Pagination.PageinationProps`1", [gen0], PageinationProps$1, () => [["RenderFunc", lambda_type(list_type(gen0), class_type("Fable.React.ReactElement"))], ["Elements", list_type(gen0)], ["PageSize", int32_type], ["StartPage", int32_type]]);
}

function render(props) {
    let children_5, arg_3, arg_2;
    const currentPageState = react.useState(props.StartPage);
    react.useEffect(() => {
        currentPageState[1](props.StartPage);
    }, [props.StartPage]);
    const nrOfRows = length(props.Elements) | 0;
    const currentSkip = (props.PageSize * (currentPageState[0])) | 0;
    if ((currentSkip < 0) ? true : (currentSkip > nrOfRows)) {
        logw(toText(printf("[Pagination] currentSkip: %i, nrOfRows: %i"))(currentSkip)(nrOfRows));
    }
    const currentTake = min(comparePrimitives, props.PageSize, max(comparePrimitives, 0, nrOfRows - currentSkip)) | 0;
    const currentRows = (length(props.Elements) < currentSkip) ? empty() : truncate(currentTake, skip(currentSkip, props.Elements));
    let genericPaginationContainerHtml;
    const matchValue = nrOfRows > props.PageSize;
    if (matchValue) {
        let paginationInfoHtml;
        const children_7 = [(children_5 = [(arg_3 = ((currentSkip + currentTake) | 0), (arg_2 = ((currentSkip + 1) | 0), toText(printf("%i-%i / %i"))(arg_2)(arg_3)(nrOfRows)))], react.createElement("span", {}, ...children_5))];
        paginationInfoHtml = react.createElement("div", {}, ...children_7);
        let buttonsHtml;
        let backButton;
        const isDisabled = (currentPageState[0]) === 0;
        const children = [getMaterialIcon("chevron_left")];
        backButton = react.createElement("button", {
            disabled: isDisabled,
            type: "button",
            className: "btn btn-outline-secondary generic-pagination-button",
            onClick: (_arg) => {
                currentPageState[1]((m) => (m - 1));
            },
        }, ...children);
        let forwardButton;
        const isDisabled_1 = nrOfRows <= (currentSkip + currentTake);
        const children_2 = [getMaterialIcon("chevron_right")];
        forwardButton = react.createElement("button", {
            disabled: isDisabled_1,
            type: "button",
            className: "btn btn-outline-secondary generic-pagination-button",
            onClick: (_arg_1) => {
                currentPageState[1]((m_1) => (m_1 + 1));
            },
        }, ...children_2);
        buttonsHtml = react.createElement("div", {
            className: "generic-pagination__buttons-container",
        }, backButton, forwardButton);
        genericPaginationContainerHtml = react.createElement("div", {
            className: "generic-pagination__container",
        }, paginationInfoHtml, buttonsHtml);
    }
    else {
        genericPaginationContainerHtml = react.createElement(react.Fragment, {});
    }
    const renderedHtml = props.RenderFunc(currentRows);
    if (nrOfRows === 0) {
        return renderedHtml;
    }
    else {
        return react.createElement("div", {
            className: "generic-pagination",
        }, renderedHtml, genericPaginationContainerHtml);
    }
}

export function Pagination() {
    return FunctionComponent_Of_Z5A158BBF(render, "PaginationComponent", uncurry(2, void 0), void 0, "Pagination", "E:\\w\\1835\\s\\FenixWebApp\\fable\\src\\Components\\Pagination\\Pagination.fs", 94);
}

